import { HttpClient, Result } from "../../../../http/HttpClient.ts";

export class KnowledgeSourceApiService {
  constructor(private readonly httpClient: HttpClient) {}

  async getKnowledgeSources(): Result<{
    knowledgeSources: { name: string; repoUrl?: string }[];
  }> {
    const response = await this.httpClient.get<{
      knowledge_sources: string[];
      knowledge_sources_list?: [
        {
          knowledge_source: string;
          ingestion_staging_folder_link?: string;
        },
      ];
    }>("/knowledge-sources");
    return {
      success: response.success,
      data: this._makeKnowledgeSourceData(response),
      httpStatus: response.httpStatus,
    };
  }

  private _makeKnowledgeSourceData(response: {
    success: boolean;
    data?: {
      knowledge_sources: string[];
      knowledge_sources_list?: [
        { knowledge_source: string; ingestion_staging_folder_link?: string },
      ];
    };
    httpStatus: number;
  }): { knowledgeSources: { name: string; repoUrl?: string }[] } | undefined {
    if (response.data?.knowledge_sources_list) {
      return {
        knowledgeSources: response.data.knowledge_sources_list.map((item) => ({
          name: item.knowledge_source,
          repoUrl: item.ingestion_staging_folder_link,
        })),
      };
    } else {
      return (
        response.data?.knowledge_sources && {
          knowledgeSources: response.data.knowledge_sources.map((name) => ({
            name,
          })),
        }
      );
    }
  }

  async getFiltersByKnowledgeSource(payload: {
    knowledgeSourceName: string;
  }): Result<{
    filters: {
      label: string;
      key: string;
      type: "selection_multiple" | "month_range";
      custom: boolean;
      options?: {
        label: string;
        value: string;
      }[];
    }[];
  }> {
    return this.httpClient.get(
      `/knowledge_source/${payload.knowledgeSourceName}/filters`,
    );
  }
}
